import SimpleLightbox from "simplelightbox";

/**
 * Place any jQuery/helper plugins in here.
 */
$(function () {
    Livewire.on('triggerDelete', model => {
        Swal.fire({
            title: 'Anda yakin untuk menghapus item ini?',
            showCancelButton: true,
            confirmButtonText: 'Ya',
            cancelButtonText: 'Tidak',
            icon: 'warning',
        }).then((result) => {
            if (result.value) {
                Livewire.emit('delete', model);
            }
        });
    });

    window.confirmAction = function (link, message = 'Anda yakin?', icon = 'warning', confirmButtonText = 'Ya', cancelButtonText = 'Tidak') {
        Swal.fire({
            title: message,
            showCancelButton: true,
            confirmButtonText: confirmButtonText,
            cancelButtonText: cancelButtonText,
            icon: icon,
        }).then((result) => {
            if (result.value) {
                window.location = link;
            }
        });

        return false;
    }

    new SimpleLightbox('.gallery a', {});
});
